import * as React from 'react';
import advantages from './img/advantages.svg';
import economy from './img/economy.svg';
import fast from './img/fast.svg';
import personal from './img/personal.svg';

import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { BlockHeader } from '../../components/BlockHeader';
import { BlockSubHeader } from '../../components/BlockSubHeader';
import { LandingBlock } from '../../components/LandingBlock';
import { ContentWrapper } from '../../components/ContentWrapper';
import { trackAdvantagesBlock } from './tracking';

import * as style from './styles.css';
import { numericFormat, TextForms } from '../../utils/formatText/numericFormat';

interface IProps {
  banksNumber: number;
}

const fromForms: TextForms = ['крупного банка', 'крупных банков', 'крупных банков'];
const getFromBankTextForm = (num: number) => numericFormat(num, fromForms);

export const AdvantagesMedia = ({ banksNumber }: IProps) => {
  return (
    <ElementInViewport onVisibleFirst={trackAdvantagesBlock}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Преимущества Циан.Ипотеки</BlockHeader>
          <BlockSubHeader>
            Всё в одном месте онлайн, с теми же условиями, что и в офисах банков. Можно взять ипотеку на квартиру в
            новостройке, на вторичном рынке или на загородную недвижимость.
          </BlockSubHeader>
          <div className={style['cards']}>
            <div className={style['card']}>
              <img className={style['img']} src={advantages} />
              <div className={style['content']}>
                <div className={style['title']}>Удобно</div>
                <div className={style['text']}>
                  Предложения от {banksNumber || 'многих'} {getFromBankTextForm(banksNumber)} страны в одном месте
                </div>
              </div>
            </div>
            <div className={style['card']}>
              <img className={style['img']} src={economy} />
              <div className={style['content']}>
                <div className={style['title']}>Бесплатно</div>
                <div className={style['text']}>Никаких дополнительных сборов и комиссий от&nbsp;сервиса</div>
              </div>
            </div>
            <div className={style['card']}>
              <img className={style['img']} src={fast} />
              <div className={style['content']}>
                <div className={style['title']}>Быстро</div>
                <div className={style['text']}>10 минут на заполнение анкеты и одобрение от&nbsp;банков</div>
              </div>
            </div>
            <div className={style['card']}>
              <img className={style['img']} src={personal} />
              <div className={style['content']}>
                <div className={style['title']}>Персонально</div>
                <div className={style['text']}>Вы задаете условия и выбираете банк с лучшим предложением</div>
              </div>
            </div>
          </div>
        </ContentWrapper>
      </LandingBlock>
    </ElementInViewport>
  );
};
